import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { useBaseCompanySubscription } from '../../hooks';


const InsuredInput: InputWithSource = ({ input }) => {
    useBaseCompanySubscription(input);

    return <GenericSelect label={input.name} input={input} />;
};

InsuredInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(InsuredInput);
